import { NgModule } from 'ng-metadata/core';
import { ColorsService } from './colors.service';

/**
 * @ngdoc module
 * @name mw.components.colors
 * @description
 *
 * Colors
 */
@NgModule({
    providers: [{ provide: 'mwColorsService', useClass: ColorsService }]
})

export class ColorsModule {}



// WEBPACK FOOTER //
// ./src/lib/components/colors/colors.module.ts